import useSession from "../../hooks/useSession";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import projectAPI from "../../services/project";
import userAPI from '../../services/user';
import { initChat } from "../../services/chat";

import OpportunityCodeModal from "../OpportunityCodeModal";

const NavBar = () => {
  const [session, setSession, removeSession] = useSession();
  const { user, getCustomItem, addCustomItem, removeUser, getL10nInstance } =
    useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const [l10n, setL10n] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  // if (user && user.position == "am") {
  if (user) {
    initChat();
  }

  useEffect(() => {
    if (sessionStorage.getItem("bunny.Project") && sessionStorage.getItem("bunny.NewProjectEvent") && sessionStorage.getItem("bunny.Reloaded")) {
      const data = JSON.parse(sessionStorage.getItem("bunny.Project"))
      const flag = JSON.parse(sessionStorage.getItem("bunny.NewProjectEvent"))
      const reloaded = JSON.parse(sessionStorage.getItem("bunny.Reloaded"))
      
      if (reloaded == false) {
        sessionStorage.setItem("bunny.Reloaded", true);
      }

      if (flag == true && reloaded == true) {
        sessionStorage.setItem("bunny.NewProjectEvent", false)
      } 
      
      if (flag == false) {
        sessionStorage.removeItem("bunny.Project")
        sessionStorage.removeItem("bunny.NewProjectEvent")
        sessionStorage.removeItem("bunny.Reloaded")
      }
    } 
  }, [location])

  const [selectedLang, setSelectedLang] = useState(null);

  const handleChange = async (event) => {
    setSelectedLang(event.target.value);
    sessionStorage.setItem("bs_language", event.target.value);
    await updateLanguage(event.target.value);
    window.location.reload();
  };

  const updateLanguage = async (language) => {
    if (!language || !user) return
    
    try {
      const payload = {email: user.email, language: language};
      await userAPI.put({payload: payload, jwt: session});
    } catch (err) {
      console.error(err);
    }
  }

  const languages = [
    { value: "en", label: "English" },
    { value: "pt", label: "Português" },
    // { value: "hi", label: "हिंदी" },
  ];

  const checkMagicLink = () => {
    const magicLink = getCustomItem("bunny.MagicLink");
    return magicLink ? false : true;
  };

  const onNewProject = async (opportunityCode) => {
    // Create project
    const dummyData = {
      opportunity_code: opportunityCode,
      fulfillment: "contest",
    };
    try {
      const res = await projectAPI.structure({
        jwt: session,
        payload: dummyData,
      });
      sessionStorage.setItem("bunny.Project", JSON.stringify(res.data.data));
      sessionStorage.setItem("bunny.NewProjectEvent", true);
      sessionStorage.setItem("bunny.Reloaded", false);
      addCustomItem("bunny.OpportunityCode", opportunityCode);
      navigate(`/widget#project`);
      navigate(0);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance();
      setL10n(instance);
    })();
  }, [session, user]);

  useEffect(() => {
    const language = user ? user.language : sessionStorage.getItem("bs_language");
    const languageNav = navigator.language.split("-")[0];
    setSelectedLang(language ? language : languageNav);
  }, [session, user]);

  const languageSelector = () => {
    return <div className="relative flex gap-2">
    <div className="w-6 h6 absolute inset-y-0 left-0 flex items-center px-1 pointer-events-none">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
      >
        <circle
          cx="8"
          cy="8"
          r="7.25"
          stroke="#FBFBFE"
          strokeWidth="1.5"
        />
        <path
          d="M8 15.25C7.7649 15.25 7.48181 15.1442 7.15894 14.8321C6.83246 14.5165 6.50419 14.0235 6.21224 13.3562C5.62932 12.0239 5.25 10.1307 5.25 8C5.25 5.86928 5.62932 3.97615 6.21224 2.64376C6.50419 1.97645 6.83246 1.48352 7.15894 1.16789C7.48181 0.855751 7.7649 0.75 8 0.75C8.2351 0.75 8.51819 0.855751 8.84106 1.16789C9.16754 1.48352 9.49581 1.97645 9.78776 2.64376C10.3707 3.97615 10.75 5.86928 10.75 8C10.75 10.1307 10.3707 12.0239 9.78776 13.3562C9.49581 14.0235 9.16754 14.5165 8.84106 14.8321C8.51819 15.1442 8.2351 15.25 8 15.25Z"
          stroke="#FBFBFE"
          strokeWidth="1.5"
        />
        <line
          x1="1"
          y1="5.75"
          x2="15"
          y2="5.75"
          stroke="#FBFBFE"
          strokeWidth="1.5"
        />
        <line
          x1="1"
          y1="10.25"
          x2="15"
          y2="10.25"
          stroke="#FBFBFE"
          strokeWidth="1.5"
        />
      </svg>
    </div>
    <select
      id="language"
      name="language"
      value={selectedLang}
      onChange={handleChange}
      className="bg-transparent appearance-none pl-6 pr-2"
    >
      {languages.map((lang) => (
        <option key={lang.value} className="text-black" value={lang.value}>
          {lang.label}
        </option>
      ))}
    </select>
  </div>
  }

  return (
    <>
      <nav className="w-full h-20 bg-[#000000] pl-10 pr-2 flex items-center text-base font-bold fixed top-0 z-20 text-white">
        <ul className="w-full flex justify-between">
          {session ? (
            <>
              <div className="flex gap-8">
                {user && user.position == "am" ? (
                  <li>
                    <Link to="/widget#dashboard" reloadDocument>
                      {l10n && l10n.getString("Project dashboard")}
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {user && user.position == "am" ? (
                  <li>
                    {/* <Link to="/widget#project" reloadDocument>
                    Create new project
                  </Link> */}
                    <button
                      type="button"
                      onClick={() => setShowModal(true)}
                      className="font-semibold text-base text-white"
                    >
                      {l10n && l10n.getString("Create new project")}
                    </button>
                  </li>
                ) : (
                  ""
                )}
                {user && user.position == "am" ? (
                  <li>
                    <Link to="/magic-link">
                      {l10n && l10n.getString("Invite to new project")}
                    </Link>
                  </li>
                ) : (
                  ""
                )}
              </div>
              <div className="flex gap-8 mr-4">
                {languageSelector()}
                {checkMagicLink() ? (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      removeSession();
                      removeUser();
                    }}
                  >
                    {l10n && l10n.getString("Log out")}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          ) : (
            <>
              <div className="w-full flex justify-end gap-8 mr-4">
                {languageSelector()}
                {location.pathname != "/guest" ? (
                  <li>
                    <Link to="/guest">
                      {l10n && l10n.getString("Start as guest")}
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Link to="/login">
                      {l10n && l10n.getString("Start as account manager")}
                    </Link>
                  </li>
                )}
              </div>
            </>
          )}
        </ul>
      </nav>

      {showModal && (
        <OpportunityCodeModal
          onInteraction={(e) => onNewProject(e)}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default NavBar;
